import React from 'react'
import "./CriteriaDetailList.css"
import { Criteria } from '../../../../types/screener.type';
import CriteriaSetting from '../CriteriaSetting/CriteriaSetting';

export interface CriteriaDetailListProps {
    region: string;
    sector: string;
    tempCriteria: Criteria[];
    selectedCriteria: Criteria[];
    setCriteria: (criteria: Criteria[]) => void;
    token: string;
}

const CriteriaDetailList = ({ region, sector, tempCriteria, selectedCriteria, setCriteria, token }: CriteriaDetailListProps) => {
    return (
        <div className="screener-criteria-detail-list">
            {selectedCriteria.length > 0 ? selectedCriteria.map(item => (
                <CriteriaSetting
                    key={item.id}
                    tempCriteria={tempCriteria}
                    criteria={item}
                    setCriteria={setCriteria}
                    region={region}
                    sector={sector}
                    token={token} />
            )) : <div className="screener-criteria-detail-list-empty">No criteria selected</div>}
        </div>
    )
}

export default CriteriaDetailList